<section *ngIf="visible" class="passkeys-intro" role="status" aria-labelledby="passkeys-intro-title">
    <div class="passkeys-intro__header">
        <h2 id="passkeys-intro-title" class="passkeys-intro__title">Nuevo: llaves de acceso</h2>
        <button
            pButton
            type="button"
            icon="pi pi-times"
            class="p-button-sm p-button-text p-button-plain p-button-rounded passkeys-intro__close"
            aria-label="Cerrar aviso"
            (click)="dismiss()"
        ></button>
    </div>
    <p class="passkeys-intro__text">Entra con tu huella, rostro o PIN en lugar de tu contraseña.</p>
    <div class="passkeys-intro__actions">
        <button pButton type="button" label="Ahora no" class="p-button-sm p-button-text p-button-secondary" (click)="dismiss()"></button>
        <button pButton type="button" label="Configurar" class="p-button-sm p-button-text" (click)="configure()"></button>
    </div>
</section>
